import { create } from 'zustand';

type CancelPauseModalStore = {
  close: () => void;
  isOpen: boolean;
  open: (params?: { onSuccess?: () => void }) => void;
  onSuccess?: () => void;
};

export const useCancelPauseModalStore = create<CancelPauseModalStore>((set) => ({
  close: () => set({ isOpen: false, onSuccess: undefined }),
  isOpen: false,
  open: (params) => set({ isOpen: true, onSuccess: params?.onSuccess }),
  onSuccess: undefined,
}));
